import { isMobile } from '@/utils';
import GuideButton from './GuideButton';
import WebGuideButton from './WebGuideButton';

export default isMobile() ? GuideButton : WebGuideButton;
